import * as React from "react";
import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import {PatientPriorityStatus} from "doctors-dashboard/http-clients/index";
import {DEFAULT_PATIENT_PRIORITY_STATUS, PatientPriorityStatuses, PatientPriorityStatusPipe} from "../../enum/patient-priority-status";
import {PatientsListPriorityStatusSelectorProps} from "./patients-list-priority-status-selector.interface";
import {usePatientsListPriorityStatusSelectorStyle} from "./patients-list-priority-status-selector.style";

export const PatientsListPriorityStatusSelector = (props: PatientsListPriorityStatusSelectorProps) => {
    const classes = usePatientsListPriorityStatusSelectorStyle();
    const selected = props.priorityStatus ?? DEFAULT_PATIENT_PRIORITY_STATUS;

    const onChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        props.onPriorityStatusChanged(event.target.value as PatientPriorityStatus);
    };

    return (
        <div className={classes.root}>
            <FormControl className={classes.control}>
                <InputLabel id='patients-list-priority-status-selector-label'>Sort status</InputLabel>
                <Select
                    id='patients-list-priority-status-selector'
                    labelId='patients-list-priority-status-selector-label'
                    disabled={props.disabled}
                    value={selected}
                    onChange={onChange}
                >
                    {PatientPriorityStatuses.map(status =>
                        <MenuItem key={status} value={status}>{PatientPriorityStatusPipe(status)}</MenuItem>)}
                </Select>
            </FormControl>
        </div>
    );
};
